export const TOPBAR_EXPANDED_USER = 'TOPBAR_EXPANDED_USER';
export const TOPBAR_EXPANDED_NOTIFICATIONS = 'TOPBAR_EXPANDED_NOTIFICATIONS';
export const TOPBAR_EXPANDED_NAV = 'TOPBAR_EXPANDED_NAV';
export const TOPBAR_EXPANDED_SETTINGS = 'TOPBAR_EXPANDED_SETTINGS';
export const TOPBAR_EXPANDED_MOBILE_NAV = 'TOPBAR_EXPANDED_MOBILE_NAV';
export type TopbarExpandedMenu =
  | 'TOPBAR_EXPANDED_USER'
  | 'TOPBAR_EXPANDED_NOTIFICATIONS'
  | 'TOPBAR_EXPANDED_NAV'
  | 'TOPBAR_EXPANDED_SETTINGS'
  | 'TOPBAR_EXPANDED_MOBILE_NAV';

export const TOPBAR_DROPDOWN_ALIGN_RIGHT = 'TOPBAR_DROPDOWN_ALIGN_RIGHT';
export const TOPBAR_DROPDOWN_ALIGN_LEFT = 'TOPBAR_DROPDOWN_ALIGN_LEFT';
export const TOPBAR_DROPDOWN_ALIGN_FULLWIDTH =
  'TOPBAR_DROPDOWN_ALIGN_FULLWIDTH';
export type TopbarDropdownAlignment =
  | 'TOPBAR_DROPDOWN_ALIGN_RIGHT'
  | 'TOPBAR_DROPDOWN_ALIGN_LEFT'
  | 'TOPBAR_DROPDOWN_ALIGN_FULLWIDTH';
